import React from 'react';
import { DEVELOPER_ROLE, OWNER_ROLE } from 'store/api/types';

import { RolesContext } from './RolesContext';
import { NONE_ROLE, RolesContextProviderProps } from './RolesContext.types';

export const RolesContextProvider = ({ roles, children }: RolesContextProviderProps) => {
  const getRoleInAccount: (
    account: string,
  ) => typeof OWNER_ROLE | typeof DEVELOPER_ROLE | typeof NONE_ROLE = account => {
    const item = roles.find(role => role.account === account);

    if (item) {
      return item.role;
    }

    return NONE_ROLE;
  };

  return (
    <RolesContext.Provider
      value={{
        getRoleInAccount,
        roles,
      }}
    >
      {children}
    </RolesContext.Provider>
  );
};
